import CardSelector from '@components/card-selector/card-selector'
import DocumentSpotlight from '@components/document-spotlight/document-spotlight'
import FloatingBox from '@components/floating-box/index'
import TestimonialV2 from '@components/testimonialv2/index'
import Timeline from '@components/timeline/index'
import VideoSpotlight from '@components/video-spotlight/index'
import WeLoveThisGameHero from '@components/we-love-this-game-hero/index'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import PropTypes from 'prop-types'

const WeLoveThisGame = (props) => {
  const {
    metaDataField,
    metaDescription,
    metaImage,
    whoWeAreSection,
    eventsCollection,
    ourHistoryHeader,
    ourHistorySupportText,
    ourHistorySupportRichText,
    testimonialsSection,
    videoSpotlight,
    categorySectionOvertext,
    categorySectionHeadline,
    categories,
    ctaCardCollectionCollection,
    categorySectionSubtitle,
    ourHistoryBackgroundImage,
    governingBodiesPdf,
    govBodiesCta,
    govBodiesImage,
    timelineStyle,
    slug,
  } = props

  return (
    <div>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaDataField}
        description={metaDescription}
        canonical={`${defaults.baseUrl}${slug}`}
        openGraph={{
          title: metaDataField,
          description: metaDescription,
          type: 'website',
          url: `${defaults.baseUrl}${slug}`,
          images: [{ url: metaImage && metaImage.url }],
        }}
      />
      <WeLoveThisGameHero {...props} />
      <FloatingBox {...whoWeAreSection} flipped />
      <VideoSpotlight flipped videoSpotlight={videoSpotlight} />
      <Timeline
        header={ourHistoryHeader}
        supportText={ourHistorySupportText}
        supportRichText={ourHistorySupportRichText}
        events={eventsCollection.items}
        backgroundImage={ourHistoryBackgroundImage}
        timelineStyle={timelineStyle}
      />
      <CardSelector
        variant
        overText={categorySectionOvertext}
        headline={categorySectionHeadline}
        categories={categories}
        cardCollection={ctaCardCollectionCollection}
        subtitle={categorySectionSubtitle}
      />
      <DocumentSpotlight
        {...govBodiesCta}
        image={govBodiesImage}
        document={governingBodiesPdf}
      />
      <TestimonialV2 testimonialsData={testimonialsSection} />
    </div>
  )
}

WeLoveThisGame.propTypes = {
  metaDataField: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.object,
  whoWeAreSection: PropTypes.object,
  testimonialsSection: PropTypes.object,
  videoSpotlight: PropTypes.object,
  categorySectionOvertext: PropTypes.string,
  categorySectionHeadline: PropTypes.string,
  categories: PropTypes.array,
  ctaCardCollectionCollection: PropTypes.object,
  categorySectionSubtitle: PropTypes.string,
  eventsCollection: PropTypes.object,
  ourHistoryHeader: PropTypes.string,
  ourHistorySupportText: PropTypes.string,
  ourHistorySupportRichText: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  ourHistoryBackgroundImage: PropTypes.object,
  governingBodiesPdf: PropTypes.object,
  govBodiesCta: PropTypes.object,
  govBodiesImage: PropTypes.object,
  timelineStyle: PropTypes.bool,
  slug: PropTypes.string,
}

export default WeLoveThisGame
